import { useAppSelector, useAppDispatch } from 'hooks/useAppDispatchSelector';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import { setModal } from 'store/features/modelSlice';
import { initModal } from 'helpers/utils';
import { useTranslation } from 'react-i18next';

const AlertCompleteConfirmation = () => {
  const { modal } = useAppSelector(state => state.modal);
  const dispatch = useAppDispatch();
  const { content } = modal;
  const handleCompleteAlert = () => {
    const { callBackFun } = content;
    if (callBackFun) {
      callBackFun();
    }
  };
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full h-full max-w-[450px]">
      <div className="flex flex-col w-full gap-y-3">
        <div className="flex items-center w-full gap-x-1">
          <label className="text-xl font-semibold text-black2 whitespace-nowrap overflow-hidden flex-1 text-ellipsis">
            {content?.title}
          </label>
        </div>
        <label className="text-base break-words font-medium text-grey9">{content?.message}</label>
        <div className="flex items-center justify-center w-full gap-x-4 mt-5">
          <PrimaryDarkButton
            label={t('workshopAppointment.steps.complete')}
            onClick={() => handleCompleteAlert()}
            width="w-1/2"
          />
          <DarkButton
            label={t('CANCEL')}
            width="w-1/2"
            onClick={() => dispatch(setModal(initModal))}
          />
        </div>
      </div>
    </div>
  );
};

export default AlertCompleteConfirmation;
